// src/directives/elImageCloseOnMask.js
/**
 * 全局指令：el-image点击空白遮罩关闭预览
 * 使用方式：<el-image v-image-close-on-mask v-image-close-on-mask ... />
 */
export default {
  // 指令挂载到元素时触发（el-image组件挂载完成）
  mounted() {
    // 监听全局点击事件（通过事件委托，性能更优）
    document.addEventListener('click', handleMaskClick)
  },
  // 指令卸载时触发（防止内存泄漏）
  unmounted() {
    document.removeEventListener('click', handleMaskClick)
  }
}

/**
 * 核心逻辑：判断点击是否为el-image预览遮罩，若是则关闭预览
 */
function handleMaskClick(e) {
  // 1. 判断是否点击了el-image预览遮罩层
  const isMaskClick = e.target?.classList?.contains('el-image-viewer__mask')
  if (!isMaskClick) return

  // 2. 找到预览组件的关闭按钮并模拟点击
  const closeBtn = document.querySelector('.el-image-viewer__close')
  if (closeBtn) {
    closeBtn.click()
  }
  
  // 【备选方案】如果模拟点击失效，可直接调用预览实例的close方法
  // const viewerInstance = document.querySelector('.el-image-viewer')?.__vue__
  // if (viewerInstance) viewerInstance.close()
}